import { ApiEndPoint, getMethod, postMethod } from "services";
import {defaultVariable} from "../../common";
import { getAccessPermissions } from "services/powerBiService";
import { MENU_ITEM_USERS_REPORT_ACCESS } from "./powerBiReportPageAction";
const LOGIN_TIME = "LOGIN_TIME";
const MENU_ITEM_MANAGE_USERS = 'MENU_ITEM_MANAGE_USERS';
const MENU_ITEM_REPORT_GLOBAL = 'MENU_ITEM_REPORT_GLOBAL';

export const fetchLoginTime = (date: any) => {
    if(!date) {
        return async (dispatch: any) => {
            await getAccessPermissions()
            .then((res:any) => {
                if (res) {
                    dispatch({
                        type: MENU_ITEM_USERS_REPORT_ACCESS,
                        payload: res
                    });  
                }
            })
            
            await postMethod(ApiEndPoint.loginTime, '', {})
            .then((res: any) => {
                if(res.status === 200) {
                    localStorage.setItem('routingDisabled',JSON.stringify(res?.data?.manageUsersEnabled));
                    if(res?.data?.role === defaultVariable.ROLES.delegate) {
                        sessionStorage.setItem('delegateId', res?.data?.id);
                    }
                    dispatch({
                        type: LOGIN_TIME,
                        payload: new Date()
                    });
                    dispatch({
                        type: MENU_ITEM_MANAGE_USERS,
                        payload: res?.data?.manageUsersEnabled
                    });                    
                }
            }).catch((err) => {
                console.log(err)
                dispatch({
                    type: LOGIN_TIME,
                    payload: ''
                });
            })

            await getMethod(ApiEndPoint.fetchReportsGlobalAccess, "")
            .then((res) => {
                if (res) {
                    dispatch({
                        type: MENU_ITEM_REPORT_GLOBAL,
                        payload: res?.data
                    });  
                }
            })
            .catch((err) => {
                console.error("Error", err);
            });
        };
    } else {
        return {
            type: LOGIN_TIME,
            payload: ''
        }
    }
};